// extracted by mini-css-extract-plugin
export var printerCard = "_c7-1";
export var printerCardConfigured = "_c7-2";
export var printerCardError = "_c7-3";
export var printerCardsContainer = "_c7-0";
export var printerIcon = "_c7-8";
export var printerIconConfigured = "_c7-5";
export var printerIconContainer = "_c7-4";
export var printerIconError = "_c7-6";
export var printerIconUnconfigured = "_c7-7";
export var workstationsTableCard = "_c7-9";